import { render } from "./GoTopButton.vue?vue&type=template&id=0840f6c7"
import script from "./GoTopButton.vue?vue&type=script&lang=js"
export * from "./GoTopButton.vue?vue&type=script&lang=js"

import "./GoTopButton.vue?vue&type=style&index=0&id=0840f6c7&lang=scss"

import exportComponent from "/Users/yanislav.pavlov/development/private/bulgartabac/bulgartabac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__